import Modal from "../../../UI/Modal";
import styles from "./WhatIs.module.css";
import exitImage from "../../../../assets/x-highlight.png";
import { useContext } from "react";
import DataContext from "../../../store/data-context";

export default function WhatIs({ onClose }) {
  const dataCtx = useContext(DataContext);

  return (
    <Modal onClose={onClose}>
      <main className={styles.main}>
        <img
          className={styles.exit}
          src={exitImage}
          alt="X"
          onClick={onClose}
        />
        <div className={styles.title}>
          {dataCtx.pageData.market.what_is_title}
        </div>
        <div className={styles.description}>
          {dataCtx.pageData.market.what_is_description}
        </div>
      </main>
    </Modal>
  );
}
